/**
 * Country to Cities Mapping
 * Imported from comprehensive countries.json data file
 * Contains 152 countries with their respective cities
 */

import countriesData from '../data/countries.json';

// Use the imported data directly
export const COUNTRY_CITY_MAPPING = countriesData;

/**
 * Get cities for a given country
 * @param {string} countryName - Country name
 * @returns {string[]} Array of city names
 */
export function getCitiesForCountry(countryName) {
  if (!countryName) return [];

  // Try exact match first
  if (COUNTRY_CITY_MAPPING[countryName]) {
    return COUNTRY_CITY_MAPPING[countryName];
  }

  // Try case-insensitive match
  const normalizedCountry = countryName.trim().toLowerCase();
  for (const [country, cities] of Object.entries(COUNTRY_CITY_MAPPING)) {
    if (country.toLowerCase() === normalizedCountry) {
      return cities;
    }
  }

  // No match found
  return [];
}

/**
 * Check if a country has cities defined
 * @param {string} countryName - Country name
 * @returns {boolean}
 */
export function hasCountryCities(countryName) {
  return getCitiesForCountry(countryName).length > 0;
}

/**
 * Get all countries that have cities defined
 * @returns {string[]} Array of country names
 */
export function getAvailableCountries() {
  return Object.keys(COUNTRY_CITY_MAPPING);
}
